/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerModals.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Modals
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, April 03, 2019 - 1:55 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      04/03/2019  NJN     File Created
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    MODAL_OPEN_SELECTWINDOW,
    MODAL_CLOSE_SELECTWINDOW
} from '../constants/actionTypeModals';

const defaultState = {
    tagName: null,
    modalType: null,
    windowselect: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case MODAL_OPEN_SELECTWINDOW:
            return {
                ...state,
                tagName: action.payload ? action.payload.tagName : '',
                modalType: action.payload ? action.payload.modalType : '',
                windowselect: true
            }
        case MODAL_CLOSE_SELECTWINDOW:
            return {
                ...state,
                tagName: '',
                modalType: '',
                windowselect: false
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerModals.js